import { createContext, useContext } from "react";

import type { SlideOverNavigatorState } from "./useSlideOverNavigator";

const SlideOverNavigationContext =
  createContext<SlideOverNavigatorState | null>(null);

export const SlideOverNavigationProvider = SlideOverNavigationContext.Provider;

export function useSlideOverNavigation(): SlideOverNavigatorState {
  const context = useContext(SlideOverNavigationContext);
  if (!context) {
    throw new Error(
      "useSlideOverNavigation must be used within SlideOverNavigator",
    );
  }
  return context;
}
